





































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import CalculatePricePO from "@/store/entities/finance/calculatepricepo";

@Component({
  components: {},
})
export default class CalculatePrice extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Array, default: [] }) billId: [];
  @Prop({ type: Number, default: 0 }) monthUse: number;
  @Prop({ type: Number, default: 0 }) monthAmmount: number;
  @Prop({ type: String, default: "" }) month: string;
  @Prop({ type: String, default: "" }) areaName: string;
  calculatepricepo: CalculatePricePO = new CalculatePricePO();
  loading: boolean = false;
  rowCount: number = 0;
  list: any[] = [];
  pageSize: number = 10;
  currentPagenum: number = 1;
  create() { }
  created() {
    this.getPrice();
    this.calculatepricepo.floatingRange = 10;
  }
  //取消
  cancel() {
    this.$emit("input", false);
  }
  //保存
  save() {
    (this.$refs.priceForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let res = await this.$store
          .dispatch({
            type: "countrybills/calculatePrice",
            data: this.calculatepricepo,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        console.log(res);
        this.loading = false;
        (this.$refs.priceForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  //显示
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  //规则
  ruleValidate = {
    monthTotalAmmount: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    monthTotalUse: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    benchmarkPrice: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    floatingRange: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    monthPrice: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    priceId: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  //获取价格
  async getPrice() {
    await this.$store
      .dispatch("price/getPriceList")
      .then((val) => {
        this.$data.price.push({ label: this.L("PleasChoose"), value: 0 });
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.price.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      price: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  @Watch("billId", { deep: true })
  @Watch("monthUse", { deep: true })
  @Watch("monthAmmount", { deep: true })
  @Watch("areaName", { deep: true })
  getitemId() {
    this.calculatepricepo.billsId = this.billId;
    this.calculatepricepo.monthTotalUse = this.monthUse;
    this.calculatepricepo.monthTotalAmmount = this.monthAmmount;
    this.calculatepricepo.month = this.month;
    this.calculatepricepo.parkName = this.areaName;
    if (this.calculatepricepo.monthTotalUse > 0) {
      this.calculatepricepo.benchmarkPrice = Number.parseFloat(
        (
          this.calculatepricepo.monthTotalAmmount /
          this.calculatepricepo.monthTotalUse
        ).toFixed(4)
      );
      this.calculatepricepo.monthPrice = Number.parseFloat(
        (
          this.calculatepricepo.benchmarkPrice +
          this.calculatepricepo.benchmarkPrice *
          (this.calculatepricepo.floatingRange / 100)
        ).toFixed(4)
      );
    }
  }
}
